import { useWidget } from '../context/WidgetContext.js';
import { useChatOptional } from '../chat/ChatProvider.js';
import { Avatar } from './Avatar.js';
import { IconClose } from './icons.js';

type ChatHeaderProps = {
  onClose: () => void;
  showManager?: boolean;
};

export function ChatHeader({ onClose, showManager = false }: ChatHeaderProps) {
  const { settings, t } = useWidget();
  const chat = useChatOptional();
  const managerName = chat?.managerName ?? null;
  const statusName = showManager
    ? managerName || t.managerBadge
    : settings.content.aiAgentName;

  return (
    <header className="teo-header">
      <Avatar className="teo-avatar--header" />
      <div className="teo-header__info">
        <div className="teo-header__title">{settings.content.shopName}</div>
        <div className="teo-header__status">
          <span className="teo-status-dot" aria-hidden />
          <span>
            {statusName} · {t.online}
          </span>
        </div>
      </div>
      <button
        type="button"
        className="teo-icon-btn teo-icon-btn--header"
        onClick={onClose}
        aria-label={t.close}
      >
        <IconClose />
      </button>
    </header>
  );
}
